import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm md:text-base">关于五一黑料网，你想知道的都在这里</p>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? 0 : item.id)}
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer"
              >
                <h3 className="font-bold text-foreground-900 text-sm md:text-base pr-4">{item.q}</h3>
                <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                  openId === item.id ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-foreground-600 text-sm leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}